import React from "react";
import { useAuth } from "../AuthContext/AuthContext";
import "./TenantSwitcher.css";

const TenantSwitcher: React.FC = () => {
  const { tenants, activeTenant, switchTenant } = useAuth();

  if (tenants.length <= 1) return null;

  return (
    <select
      className="tenant-switcher"
      value={activeTenant?.slug || ""}
      onChange={(e) => switchTenant(e.target.value)}
    >
      {tenants.map((t) => (
        <option key={t.slug} value={t.slug}>
          {t.display_name}
        </option>
      ))}
    </select>
  );
};

export default TenantSwitcher;
